import Form from 'mlmi-library/components/form/v1/form'

$.fn.FormProfile = function() {
  let self = this
  self.form = undefined

  self.handle_success = function(response) {
    //
  }

  self.initialize_form = function() {
    self.form = new Form('.profile-form', {
      auto_scroll: true,
    })
  }

  self.initialize_fields = function() {
    self.find('select[name="activite_secteur"]').on('change', function() {
      if ($(this).val() == 44) {
        $('.field-container--discipline').addClass('visible')
      } else {
        $('.field-container--discipline').removeClass('visible')
      }
    })

    self.find('input[name="type_adresse"]').on('change', function() {
      if ($(this).val() == 'personnelle') {
        $('.field-container--fonction').addClass('hidden')
        $('.field-container--organisation .field-instruction').show()
      } else {
        $('.field-container--fonction').removeClass('hidden')
        $('.field-container--organisation .field-instruction').hide()
      }
    })

    self.find('select[name="province"]').on('change', function() {
      if ($(this).val() == 'Hors Canada') {
        $('.field-container--pays').addClass('visible')
      } else {
        $('.field-container--pays').removeClass('visible')
      }
    })
  }

  self.update_fields = function() {
    //
  }

  return function() {
    self.initialize_form()
    self.initialize_fields()
    return self
  }()
}
